
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSearchlightColourOn as ObiLightSearchlightColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-searchlight-colour-on.js';
 
 
 

 
 export const ObiLightSearchlightColourOn = createComponent({
   react: React,
   tagName: 'obi-light-searchlight-colour-on',
   elementClass: ObiLightSearchlightColourOnElement,
   events: {
     
   }
  });
 
 